// extracted by mini-css-extract-plugin
export default {"BasePageForm":"BasePageForm_BasePageForm__5BSqS"};